"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function LuxuryResidentialRenovations() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const services = [];
  return <section id="luxury-residential-renovations" ref={ref} className="bg-primary ![padding:10px_0px_96px_0px] lg:![padding:96px_0px_96px_0px]">
      <div className="container mx-auto px-6 lg:px-12 max-w-[1400px]">
        <div className="grid gap-12 items-start transition-all duration-700 opacity-100 translate-y-0 ![margin:20px_0px_20px_0px] lg:grid-cols-2 lg:gap-16">
          {}
          <div className="space-y-6 ![margin:40px_0px_0px_0px]">
            <div className="flex gap-2 text-xs uppercase tracking-[2px] text-foreground font-sans">
              <span className="!text-[hsl(32,29%,42%)]">Residential Services</span>
              <span>•</span>
              <span className="!text-[hsl(32,29%,42%)]">OFFICE & COMMERCIAL RENOVATIONS</span>
              <span>•</span>
              <span className="!text-[hsl(32,29%,42%)]">DESIGN & BUILD</span>
            </div>

            <h2 className="font-display text-4xl font-semibold text-foreground leading-tight !text-left lg:text-5xl">Luxury Renovation & Design Services in Cyprus</h2>

            <p className="font-sans text-muted-foreground leading-relaxed !text-lg">At KS LUXURY RENOVATIONS, we deliver fully integrated renovation solutions for high-end residential and commercial projects in Cyprus.</p>
            <p className="font-sans text-muted-foreground leading-relaxed !text-lg">Every service is designed to provide clarity, quality, and long-term value, without compromise.</p>
          </div>

          {}
          <div className="space-y-8">
            <img src="https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/02/male-worker-using-wood-cutting-circular-saw-machine-workshop_1920.jpg" alt="Luxury Villa Renovation" className="w-full h-auto rounded-lg shadow-medium object-cover aspect-[4/3]" />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {services.map((service, i) => <Card key={service.id} data-index={i} className="group overflow-hidden bg-light-background shadow-soft hover:shadow-medium transition-all duration-[350ms] ease-[var(--ease-out-back)] hover:-translate-y-1">
                  <div className="overflow-hidden rounded-t-xl">
                    
                  </div>
                  <div className="p-5">
                    <h5 className="font-sans text-xl font-semibold text-foreground transition-colors duration-[350ms] group-hover:text-accent-dark">
                      {service.title}
                    </h5>
                  </div>
                </Card>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}